/**
 * EvaluateCalculationElements — `.calculation-element` pass (REQ-PRICE-4):
 * instant .html() update (no queued animation — the counter-queue fix,
 * research/04 §7.2), dual data-val sync (.data + attr — §7.3),
 * data-origMoney set every run, hidden #calculation_inp_<sanitizedName>
 * update (spaceRegex/specialCharactersRegex), Nova short-circuit (§2.8).
 *
 * The eval lives in formula/evaluate.ts (the single eval boundary);
 * evaluateCalculationElementFormula re-declares this callback's v1 locals so
 * direct-eval identifier capture is unchanged (ERRATA #10).
 */
import { appState } from "../state/app-state";
import { FormulaParser, evaluateCalculationElementFormula } from "../formula";
import { HasPriceTickerFormattedWithNovaCurrency } from "../currency";
import $ from "jquery";

export function EvaluateCalculationElements(): void {
  $(".calculation-element").each((d: any, elem: any) => {
    let elem_formula = $(elem).data("formula");
    let elem_formula_minvalue = $(elem).data("minvalue");
    let elem_current_value = $(elem).data("val");
    let elem_decimals = $(elem).data("decimals");
    let element_name = $(elem).data("element_name");
    let parsedFormula = FormulaParser(elem_formula.toString());
    let evaluatedValue = evaluateCalculationElementFormula(
      parsedFormula as any,
      d,
      elem,
      elem_formula,
      elem_formula_minvalue,
      elem_current_value,
      elem_decimals,
      element_name,
    );
    let elem_finalValue = Math.max(elem_formula_minvalue, evaluatedValue);
    $(elem).attr("data-origMoney", elem_finalValue);
    if (elem_finalValue != elem_current_value && !isNaN(elem_finalValue)) {
      let element_parsedValue = Number(elem_finalValue).toFixed(elem_decimals);

      // Update the display directly — no queued animation.
      //
      // The old approach used jQuery .animate({ Counter }) which added a new
      // 200 ms animation to the element's queue on every input change. When the
      // user types quickly (or any other element triggers rapid recalculations)
      // the queue grows faster than it drains, so the displayed value lags far
      // behind the actual computed value.  .stop(true, true) was tried but
      // caused the UI to freeze because it runs all pending step callbacks
      // synchronously. Calculation elements (Kvadratmeter, Pris pr. plade, …)
      // are informational outputs — they don't need a smooth counter effect,
      // just an accurate, immediate value.
      if (!HasPriceTickerFormattedWithNovaCurrency(elem_finalValue, elem)) {
        $(elem).html(element_parsedValue);
      }

      // Sync data-val in BOTH the jQuery data cache and the DOM attribute.
      // Previously only .data() was called; the DOM attribute stayed at "0"
      // forever, so after any re-render elem_current_value would read back as
      // "0" and the condition above would always be true even when nothing
      // changed (causing needless updates on every recalculation).
      $(elem).data("val", element_parsedValue);
      $(elem).attr("data-val", element_parsedValue);

      element_name = element_name.replace(appState.spaceRegex, "_");
      element_name = element_name.replace(appState.specialCharactersRegex, "");
      $("#calculation_inp_" + element_name).val(
        element_parsedValue,
      );
      elem_current_value = element_parsedValue;
    }
  });
}
